import { render, staticRenderFns } from "./queryviewlistdetail.vue?vue&type=template&id=01c579d2&"
import script from "./queryviewlistdetail.vue?vue&type=script&lang=js&"
export * from "./queryviewlistdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports